import React from 'react';
import { AccessibilityWrapper, notify } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import axios from 'axios';
import { SubmissionError } from 'redux-form';
import { toast } from 'chameleon/ui-stack/ui/toast';

const ReOpen = ({ onReOpen = null, assignmentId, afterReopen = null }) => {
  const reopenClicked = (e) => {
    e.stopPropagation();
    const data = { status: 'opened' };

    axios({
      method: 'put',
      url: `${FYM_BACKEND_URL}/assessments/api/assignments/${assignmentId}/`,
      data,
    }).then((response) => {
      if (response.data && response.data.errors) {
        throw new SubmissionError(response.data.errors);
      } else if (response.status >= 400) {
        notify.error(
          `${response.data.message} Please, contact the support team.`,
          { timeout: 5 },
        );
      } else {
        toast('Successfully Re-Opened', { timeout: 5 });
        afterReopen && afterReopen();
      }
    });
  };

  return (
    <AccessibilityWrapper>
      <SingleAction
        onClick={onReOpen || reopenClicked}
        tabIndex={0}
        aria-label="Re-open Assignment"
        iconName="mark_complete_filled"
      >
        <span className="item-text">Re-Open</span>
      </SingleAction>
    </AccessibilityWrapper>
  );
};

export default ReOpen;
